@let _options = options();

<div class="row m-0" [style.display]="state() === 'inactive' ? 'none' : ''">
        @if (title()) {
            <div [class]="_options.titleClass" [attr.aria-label]="title()">
                {{ title() }}
            </div>
        }
        @if (message() && _options.enableHtml) {
            <div role="alert" [class]="_options.messageClass" [innerHTML]="message()"></div>
        }
        @if (message() && !_options.enableHtml) {
            <div role="alert" [class]="_options.messageClass" [attr.aria-label]="message()">
                {{ message() }}
            </div>
        }
        @if (message() && _options.progressBar) {
            <div >
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
        }
</div>

